export class Prop {
  constructor(name, id, relation, coordinates) {
    this.name = name;
    this.id = id;
    this.relation = relation;
    this.animation;
    this.xPos = Math.ceil(coordinates.x * this.relation);
    this.yPos = Math.ceil(coordinates.y * this.relation);
    this.depth = Math.ceil(coordinates.depth * this.relation);
    //  this.size = Math.ceil(size * this.relation);
    this.xOffset = Math.ceil(coordinates.offset.x * this.relation);
    this.yOffset = Math.ceil(coordinates.offset.y * this.relation);
    this.frontal = coordinates.frontal;
    //    this.actions = actions;
    //    this.settings = settings;

    this.polygon = coordinates.polygon;
    this.defineArea();
    if ("img" in coordinates) {
      this.height = coordinates.size.height;
      this.width = coordinates.size.width;
      this.imgSrc = require("@/assets/inventory/" + coordinates.img);
      this.setImage();
    }
  }
  draw() {}
  setImage() {
    //    if(this.settings.inventory != true){
    //        self.draw();
    //    }
    //    self.stroke();
    this.img = new Image();
    this.img.src = this.imgSrc;
    // ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  }
  defineArea() {
    let polygon = [...this.polygon];

    this.prop = new Path2D();
    let first = polygon.shift(); //get first point
    this.prop.moveTo(this.rel(first.x), this.rel(first.y));

    //this.ctx.beginPath();
    //this.ctx.moveTo(this.rel(first.x), this.rel(first.y)); //draw first point
    for (let point of polygon) {
      //draw rest of the polygon
      this.prop.lineTo(this.rel(point.x), this.rel(point.y)); //draw points
      //this.ctx.lineTo(this.rel(point.x),this.rel(point.y)); //draw points
    }
    this.prop.closePath(); //finsish polygon
  }
  rel(val) {
    return Math.ceil(this.relation * val);
  }
  stroke() {
    /*    ctx.lineWidth = 2;
        ctx.strokeStyle = '#f653a6';
        ctx.stroke();*/
  }
  hint(ctx) {
    let polygon = [...this.polygon];

    let first = polygon.shift();
    ctx.beginPath();
    ctx.moveTo(this.rel(first.x), this.rel(first.y)); //draw first point
    for (let point of polygon) {
      //draw rest of the polygon
      ctx.lineTo(this.rel(point.x), this.rel(point.y)); //draw points
      //this.ctx.lineTo(this.rel(point.x),this.rel(point.y)); //draw points
    }
    ctx.closePath(); //finsish polygon
    ctx.lineWidth = 2;
    //    ctx.fillStyle = '#f653a6';
    //    ctx.fill();
    ctx.strokeStyle = "#f653a6";
    ctx.stroke();
  }
  get area() {
    return this.prop;
  }
  get xMoveto() {
    return Math.ceil(this.xPos + this.xOffset);
  }
  get yMoveto() {
    return Math.ceil(this.yPos + this.yOffset);
  }
  get image() {
    return "img" in this ? this.img : false;
  }
  get pos() {
    return [this.xPos, this.yPos, this.depth, this.frontal];
  }
}
